import { useEffect, useState } from 'react';
import { TFunctionResult } from 'i18next';
import { Box, SxProps, Theme } from '@mui/material';
import clsx from 'clsx';

// Models
import { ResultState } from '../../models/shared.types';

// Styles
import styles from './ResultMessage.module.scss';

type ResultMessageProps = {
  message: TFunctionResult | string;
  classes?: string;
  padding?: string;
  state: ResultState;
  errorAbsolut?: boolean;
};

export const ResultMessage = (props: ResultMessageProps) => {
  // Component state
  const [sxColors, setSxColors] = useState<SxProps<Theme> | undefined>(
    undefined
  );

  useEffect(() => {
    let color: string | undefined = undefined;
    switch (props.state) {
      case ResultState.Error:
        color = 'error.main';
        break;
      case ResultState.Info:
        color = 'info.main';
        break;
      case ResultState.Success:
        color = 'success.main';
        break;
      case ResultState.Warning:
        color = 'warning.main';
        break;
      default:
        color = 'text.primary';
        break;
    }

    // Set result message color by result state
    setSxColors({
      color,
    });
  }, [props]);

  return (
    <Box
      sx={{ ...sxColors }}
      className={clsx(
        styles['result-message'],
        props.classes && props.classes,
        props.padding && props.padding,
        props.errorAbsolut && styles['error-absolut']
      )}
    >
      {props.message}
    </Box>
  );
};
